<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [verifyRequiredValidator]="verifyRequiredValidator"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [resizeHorizontal]="true" [resizeHorizontalMin]="450" [resizeVertical]="true"
    [resizeVerticalMin]="500">

    <div class="email-section">
        <div class="modal-row">
            <div class=""><span>Send Email notification(s) to:</span></div>
        </div>
        <div class="email-container">
            <res-key-value-list [placeholderField1]='"Enter or paste Email addresses ... "' [rows]="allEmails"
                [queryColumnHidden]="true" automationId="email-delivery-" [validateName]="false" [maxNameLength]="255"
                [showClearNameBtn]="true">
            </res-key-value-list>
        </div>
    </div>

    <div class="notification-section">
        <div class="modal-row">
            <div class=""><span>Include the following notification(s):</span></div>
        </div>

        <div class="checkbox-section">
            <res-custom-checkbox [automationId]="modalAutomationId + '-'" content="Success/Warning"
                [(ngModel)]="successChecked"></res-custom-checkbox>
            <res-custom-checkbox [automationId]="modalAutomationId + '-'" content="Failure"
                [(ngModel)]="failureChecked"></res-custom-checkbox>
        </div>
    </div>
</res-base-modal>